import slideTo from '/expert/mobile/slideTo.js';
import slideToLoop from '/expert/mobile/slideToLoop.js';
import slideNext from '/expert/mobile/slideNext.js';
import slidePrev from '/expert/mobile/slidePrev.js';
import slideReset from '/expert/mobile/slideReset.js';
import slideToClosest from '/expert/mobile/slideToClosest.js';
import slideToClickedSlide from '/expert/mobile/slideToClickedSlide.js';

export default {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide,
};
